import { useQuery } from '@tanstack/react-query';
import { RQ_DEPLOY_SUMMARY } from 'Utils';
import { getDeploymentSummary } from 'Services';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';

function useDeploySummary(shouldShowScheduledDeployment?: boolean) {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery([RQ_DEPLOY_SUMMARY], () => getDeploymentSummary(templateRepositoryId!), {
        enabled: !!(templateRepositoryId && templateRepositoryId > 0),
        cacheTime: 0,
        refetchInterval: shouldShowScheduledDeployment && 60 * 1000,
        refetchOnReconnect: true
    });
}

export default useDeploySummary;
